import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailFormComponent } from './email-form/email-form.component';
import { AddressesFormComponent } from './addresses-form/addresses-form.component';
import { LinkModule, LocalLoaderModule, InputModule, SystemIconModule, AlertModule, ButtonModule, CardModule } from '@serviceos-ng/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PhonesFormComponent } from './phones-form/phones-form.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { PreferenceAlertComponent } from './preference-alert/preference-alert.component';
import { ContactDetailsComponent } from './contact-details/contact-details.component';

@NgModule({
  declarations: [
    EmailFormComponent,
    AddressesFormComponent,
    PhonesFormComponent,
    PreferenceAlertComponent,
    ContactDetailsComponent
  ],
  imports: [
    CommonModule,
    SystemIconModule,
    LinkModule,
    ReactiveFormsModule,
    LocalLoaderModule,
    InputModule,
    CardModule,
    AlertModule,
    ButtonModule,
    NgxIntlTelInputModule
  ],
  exports: [
    EmailFormComponent,
    AddressesFormComponent,
    PhonesFormComponent,
    PreferenceAlertComponent,
    ContactDetailsComponent
  ]
})
export class ContactDetailsModule { }
